<template>
  <div v-show="canWrite" class="w-100">

    <form @submit.prevent="saveForm">
      <h2 class="mb-3">Eingang</h2>

      <div v-if="isAppCollectionPoint || batch.productId > 1" class="row">
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeight">Brutto-Gewicht</label>
          </div>
          <input v-model="grossWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="grossWeight" placeholder="" @change="setGrossDateTime()">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>
        <div class="input-group col-4 w55 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeightDate">D</label>
          </div>
          <input v-model="grossWeightDate" class="form-control form-control-lg"
                 id="grossWeightDate" placeholder="TT.MM.JJJJ" pattern="\d{1,2}.\d{1,2}.\d{4}">
        </div>
        <div class="input-group col-4 w45 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeightTime">Z</label>
          </div>
          <input v-model="grossWeightTime" class="form-control form-control-lg"
                 id="grossWeightTime" placeholder="HH:mm">
        </div>

        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="licensePlateNumber">Kennzeichen</label>
          </div>
          <input v-model="licensePlateNumber" class="form-control form-control-lg" id="licensePlateNumber" placeholder="">
        </div>

        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeight">Tara-Gewicht</label>
          </div>
          <input v-model="tareWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="tareWeight" placeholder="" @change="setTaraDateTime()">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>
        <div class="input-group col-4 w55 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeightDate">D</label>
          </div>
          <input v-model="tareWeightDate" class="form-control form-control-lg"
                 id="tareWeightDate" placeholder="TT.MM.JJJJ" pattern="\d{1,2}.\d{1,2}.\d{4}">
        </div>
        <div class="input-group col-4 w45 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeightTime">Z</label>
          </div>
          <input v-model="tareWeightTime" class="form-control form-control-lg"
                 id="tareWeightTime" placeholder="HH:mm">
        </div>

      </div>

      <!--div v-if="isPumpkin" class="row">
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="breed">Sorte</label>
          </div>
          <input v-model="breed" class="form-control form-control-lg" id="breed" placeholder="">
        </div>
      </div-->

      <div class="row">
        <div v-if="showBatchSampleNumber" class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="sampleNumber">Probe Nr</label>
          </div>
          <input v-model="sampleNumber" class="form-control form-control-lg" id="sampleNumber" placeholder="">
        </div>
      </div>

      <div v-if="isGrain" class="row">
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dockage">Besatz</label>
          </div>
          <input v-model="dockage" type="number" step=".01" class="form-control form-control-lg"
                 id="tareWeight" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="moisture">Feuchtigkeit</label>
          </div>
          <input v-model="moisture" type="number" step=".01" class="form-control form-control-lg"
                 id="moisture" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="hectoliter">Hektoliter</label>
          </div>
          <input v-model="hectoliter" type="number" step=".01" class="form-control form-control-lg"
                 id="hectoliter" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="protein">Protein</label>
          </div>
          <input v-model="protein" type="number" step=".01" class="form-control form-control-lg"
                 id="tareWeight" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="stockLocation">Lagerort</label>
          </div>
          <input
              v-if="!stores"
              v-model="stockLocation" class="form-control form-control-lg"
                 id="stockLocation" placeholder="">
          <select v-else
                  v-model="stockLocation"
                  class="custom-select custom-select-lg" id="stockLocation">
            <option
                v-for="(item,index) in stores"
                :key="index"
                :value="item">{{ item }}</option>
          </select>
        </div>
      </div>
    </form>

    <workflow-notes :note-data="noteData" :can-write="canWrite"/>

    <div v-if="storing" class="col-8 mt-3 text-center">
      Die Daten werden gespeichert...
    </div>
    <div v-if="storedData" class="col-8 mt-3 text-right">
      <img class="opened" src="@/assets/images/icon-done.svg"/>
      gespeichert
    </div>
    <button @click="storeWorkflowData" class="mt-5 mb-3" type="button" :disabled="storing">Zwischenspeichern</button>

  </div>
  <div
      v-if="grossWeight && tareWeight"
      class="row">
    <h2>Gewicht</h2>
    <ul class="output col-8">
      <li class="bold">
        <label class="col-3 bold">Netto</label> {{ globalFunctions.parseNumber(totalWeight()) }} kg
      </li>
      <li
          v-if="dockage"
          class="bold">
        <label class="col-3 bold">- Besatz</label> {{ globalFunctions.parseNumber(totalMinusDockage()) }} kg
      </li>
    </ul>
  </div>
  <div v-show="canWrite" class="w-100">
    <button @click="finishWorkflowStep" type="button" class="done" :disabled="storing">Abschluss</button>
  </div>
</template>

<script>
import { inject } from 'vue'
import WorkflowNotes from "@/components/WorkflowNotes.vue";
import dayjs from "dayjs";

export default {
  name: "BagList",
  components: {
    WorkflowNotes,
  },
  data() {
    return {
      workflowStep: 10,
      grossWeight: null,
      grossWeightDate: null,
      grossWeightTime: null,
      licensePlateNumber: null,
      tareWeight: null,
      tareWeightDate: null,
      tareWeightTime: null,
      breed: null,
      sampleNumber: '',
      dockage: null,
      moisture: null,
      hectoliter: null,
      protein: null,
      stockLocation: null,
      noteData: {
        text: '',
        images: null,
      },
      storedData: false,
      globalFunctions: inject('globalFunctions'),
      storing: false,
    }
  },
  props: {
    batch: {
      type: Object,
      required: true
    },
    canWrite: {
      type: Boolean,
      required: true
    },
  },
  created() {
    const batch = this.$props.batch
    this.fillForm(batch)
  },
  /* async mounted() {
    const batch = this.$props.batch
    console.log('incoming mounted', batch, batch.grossWeight)
  },*/
  computed: {
    showBruttoTara() {
      //return false
      return this.$store.getters.incomingBruttoTara
    },
    showBatchSampleNumber() {
      return this.$store.getters.batchSampleNumber
    },
    isPumpkin() {
      return this.$props.batch.productId == 1
    },
    isGrain() {
      return this.$props.batch.productId > 1
    },
    stores() {
      return this.$store.getters.stores
    },
    isAppCollectionPoint() {
      return this.$store.getters.appCollectionPoint
    },
  },
  methods: {
    fillForm(batch) {
      if (!batch) return
      this.grossWeight = batch.grossWeight
      this.licensePlateNumber = batch.licensePlateNumber
      this.tareWeight = batch.tareWeight
      this.breed = batch.breed
      this.sampleNumber = batch.sampleNumber
      this.dockage = batch.dockage
      this.moisture = batch.moisture
      this.hectoliter = batch.hectoliter
      this.protein = batch.protein
      this.stockLocation = batch.stockLocation

      if (batch.grossWeightDateTime) this.setFieldDateTime('grossWeight', batch.grossWeightDateTime)
      if (batch.tareWeightDateTime) this.setFieldDateTime('tareWeight', batch.tareWeightDateTime)
      if (batch.comment) {
        const comment = batch.comment.find(comment => comment.workflowState == 10)
        if (comment) this.noteData.text = comment.comment
      }
    },
    totalWeight() {
      return this.grossWeight - this.tareWeight
    },
    totalMinusDockage() {
      const total = this.totalWeight()
      return total - (total * this.dockage / 100)
    },
    async storeWorkflowData(resetStoring = true) {
      this.storing = true
      this.storedData = false

      const data = this.getFormData()

      const response = await this.$store.dispatch('uploadItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (resetStoring)
        this.storing = false
      if (response && response.success) {
        this.storedData = true
        // reset images
        this.noteData.images = null
      }
    },
    async finishWorkflowStep() {
      await this.storeWorkflowData(false)

      const data = {
        finishWorkflowStep: this.workflowStep,
      }

      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id: this.batch.batchId, data})

      this.storing = false
      if (response && response.success) {
        const data = this.getFormData()

        this.$emit('finishedWorkflowStep', { data: {
          ...data,
          workflowState: response.workflowState,
        }});
      }
    },
    getFormData() {
      const data = {
        workflowStep: this.workflowStep,
        noteText: this.noteData.text,
        noteImages: this.noteData.images,
      }

      if (this.isPumpkin) {
        data.breed = this.breed
      }
      if (this.isGrain) {
        data.dockage = this.dockage
        data.protein = this.protein
        data.moisture = this.moisture
        data.hectoliter = this.hectoliter
      }
      if (this.showBatchSampleNumber) {
        data.sampleNumber = this.sampleNumber
      }
      if (this.isAppCollectionPoint || this.showBruttoTara || this.isGrain) {
        data.grossWeight = this.grossWeight
        data.grossWeightDate = this.grossWeightDate
        data.grossWeightTime = this.grossWeightTime
        data.licensePlateNumber = this.licensePlateNumber
        data.tareWeight = this.tareWeight
        data.tareWeightDate = this.tareWeightDate
        data.tareWeightTime = this.tareWeightTime
        data.stockLocation = this.stockLocation
      }

      return data
    },
    saveForm() {
    },
    setGrossDateTime() {
      if (!this.grossWeightDate) this.grossWeightDate = dayjs().format('DD.MM.YYYY')
      if (!this.grossWeightTime) this.grossWeightTime = dayjs().format('HH:mm')
    },
    setTaraDateTime() {
      if (!this.tareWeightDate) this.tareWeightDate = dayjs().format('DD.MM.YYYY')
      if (!this.tareWeightTime) this.tareWeightTime = dayjs().format('HH:mm')
    },
    setFieldDateTime(field, datetime) {
      if (datetime) {
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)
        this[field +'Date'] = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
        this[field +'Time'] = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
      } else {
        this[field +'Date'] = dayjs().format('DD.MM.YYYY')
        this[field +'Time'] = dayjs().format('HH:mm')
      }
    },
  },
}
</script>